import { render } from "./Plugin.vue?vue&type=template&id=6e4d2b61&scoped=true&lang=true"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"

import "./Plugin.vue?vue&type=style&index=0&id=6e4d2b61&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-6e4d2b61"

export default script